import PermanentResource from './PermanentResource';
export default PermanentResource;
